// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import tripBookingEntity from './entities/trip-booking.json';
import tripBookingMenu from '../pages/trip-booking/menu.json';
import tripBookingFullForm from '../pages/trip-booking/forms/full.json';
import tripBookingContextForm from '../pages/trip-booking/forms/context.json';
import tripBookingMiniForm from '../pages/trip-booking/forms/mini.json';
import tripBookingLookupForm from '../pages/trip-booking/forms/lookup.json';
import tripBookingTableView from '../pages/trip-booking/views/table.json';
import tripBookingCardsView from '../pages/trip-booking/views/cards.json';
import tripBookingCalendarView from '../pages/trip-booking/views/calendar.json';
import tripBookingDashboardView from '../pages/trip-booking/views/dashboard.json';

/** Тип запису «Бронювання» зі сторінками пакета: меню, форми та подання з pages/trip-booking/. */
export const tripBookingDefinition: IRecordTypeDefinition = {
  ...tripBookingEntity,
  views: assembleViewSet({
      table: tripBookingTableView,
      cards: tripBookingCardsView,
      calendar: tripBookingCalendarView,
      dashboard: tripBookingDashboardView,
  }),
  form: tripBookingFullForm,
  forms: { full: tripBookingFullForm, context: tripBookingContextForm, mini: tripBookingMiniForm, lookup: tripBookingLookupForm },
  menu: tripBookingMenu,
} as IRecordTypeDefinition;
